<pbc-filter [config]="GutachtenFilterConfig" [filter]="gutachtens.filter$ | async" (filterChange)="gutachtens.filter$.next($event)"></pbc-filter>
